<template>
  <b-container class="container-content">
    <div class="page-header">
      <h4 class="page-header-text">{{ $t('nav.my_favorite_maid') }}</h4>
    </div>
    <b-row v-if="!isLoading">
      <b-col
        cols="12"
        md="6"
        lg="4"
        xl="3"
        v-for="maid in maids"
        :key="maid.id"
        v-if="maid.isFavorite"
      >
        <maid
          :detail="maid"
          :hasFavIcon="true"
          :isFavoriteMaid="maid.isFavorite"
          :isLoading="isUpdatingFavMaid"
        />
      </b-col>
    </b-row>
    <div v-if="!isLoading && totalMaids === 0" class="text-center">
      <p>
        {{ $t('my_favorite_maid.no_maids_selected') }}
      </p>
      <b-link :to="{ name: 'Maids' }">{{ $t('my_favorite_maid.view_all_maids') }}</b-link>
    </div>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { createNamespacedHelpers } from 'vuex'
import Maid from '../components/Maid'

const MaidStore = createNamespacedHelpers('maid')

@Component({
  components: { Maid },
  computed: {
    ...MaidStore.mapState(['favoriteMaid', 'recentlyUnFavMaids', 'isUpdatingFavMaid']),
  },
  methods: {
    ...MaidStore.mapActions(['fetchMyFavoriteMaids']),
  }
})
export default class MyMaidFavorite extends Vue {
  isLoading = true

  async created() {
    await this.fetchMyFavoriteMaids()
    this.isLoading = false
  }

  get totalMaids() {
    return this.favoriteMaid.length + this.recentlyUnFavMaids.length
  }

  get maids() {
    const unFavMap = new Map(this.recentlyUnFavMaids.map((maid) => [maid.id, maid]))
    const favMaids = this.favoriteMaid
      .filter((maid) => !unFavMap.has(maid.id))
      .map((maid) => ({ ...maid, isFavorite: true }))
    const unFavMaids = this.recentlyUnFavMaids.map((maid) => ({ ...maid, isFavorite: false }))
    return [...favMaids, ...unFavMaids].sort((a, b) => a.id - b.id)
  }
}
</script>
